;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.Share = Backbone.Model.extend({
		game_type: '',
		defaults: {
			templates: {
				share: {
					title:   _.template('<%= game_type %> TIPPING'),
					message: _.template('I have just registered for <%= game_type %> Tipping. Sign up and join in here'),
					img:     'logo.jpg'
				},
				invite: {
					title:   _.template('<%= game_type %> TIPPING'),
					message: _.template('<%= team %> is entered in <%= league %> league on <%= game_type %> Tipping! ' +
						'Looking forward to season 2017. Sign up and join here'),
					img:     'logo.jpg'
				},
				share_ladder: {}
			}
		},
		share: function(data) {
			return this.callApi(data, 'share');
		},
		invite: function(data) {
			return this.callApi(data, 'invite');
		},
		shareLadder: function(data){

			return this.callApi(data, 'share_ladder');
		},
		callApi: function(data, type){
			console.log(data, type);
			if(!data || !data.type || !type) return this;

			var
				template = this.get('templates')[type],
				callback = this._show[data.type]
			;

			data.game_type = this.game_type;

			if(!callback) return this;

			return callback(template, data);
		},
		_show: {
			facebook: function(template, data) {
				var link    = template.link ? CONFIG.ABSPATH + template.link : CONFIG.ABSPATH;

				APP.FGPFacebook.share(link)


				return this;
			},
			twitter: function(template, data) {
				var message = template.message(data) || '',
					link    = template.link ? CONFIG.ABSPATH + template.link : CONFIG.ABSPATH;

				window.open(
					'https://twitter.com/intent/tweet?url=' + encodeURIComponent(link) +
					'&text=' + encodeURIComponent(message),
					'twitter-share-dialog',
					'width=626,height=436'
				);

				return this;
			},
			whatsapp: function (template, data) {
				var message = template.message(data) || '',
					link    = template.link ? CONFIG.ABSPATH + template.link : CONFIG.ABSPATH;
				console.log('whatsapp://send?text=' + encodeURIComponent(link) + encodeURIComponent(message));

				window.open('whatsapp://send?text=' + encodeURIComponent(link) + ' ' + encodeURIComponent(message));
			}
		}
	});
}(window, APP, Backbone, Marionette, $, _));